import app from 'flarum/forum/app';
let registrationPromise;
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return undefined;
  const basePath = app.forum.attribute('basePath').replace(/\/$/, '');
  await navigator.serviceWorker.register(`${basePath}/sw`, {
    scope: `${basePath}/`
  });
  return await navigator.serviceWorker.ready;
}
export function getServiceWorkerRegistration() {
  registrationPromise ??= registerServiceWorker();
  return registrationPromise;
}